import { Auth } from 'aws-amplify';

import { AImage } from 'components/atoms';

import { useEffect, useRef, useState } from 'react';

import { logoutIcon } from 'utils/assets';
import { logout as logoutCleanState, selectUserInfo, setProfilePhoto } from 'store';

import './ProfileCircleCard.scss';
import { useSelector } from 'react-redux';

import { useGetProfilePhotoQuery } from 'services/talentoAPI/hiringAPI';
import { useAppDispatch } from 'store/hooks';

export const ProfileCircleCard = ({
  name,
  secondName,
  header = false,
  isLogOutButton = true,
}: any) => {
  const { data, isLoading, isError, refetch: refetchPhoto } = useGetProfilePhotoQuery();

  const [logout, setLogout] = useState(false);
  const dispatch = useAppDispatch();
  const cardRef = useRef<HTMLDivElement>(null);
  const { profilePhoto } = useSelector(selectUserInfo);

  const handleClick = async () => {
    await Auth.signOut();
    dispatch(logoutCleanState());
    localStorage.removeItem('alertClosed');
  };

  useEffect(() => {
    refetchPhoto();
  }, [refetchPhoto]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (cardRef.current && !cardRef.current.contains(event.target as Node)) {
        setLogout(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (isError || isLoading || !data) {
      return;
    }
    dispatch(setProfilePhoto({ profilePhoto: data }));
  }, [data, isLoading, isError, dispatch]);

  const LOGOUT = 'Cerrar sesión';

  return (
    <div
      className='profile-card'
      onClick={() => isLogOutButton && setLogout((prevLogout) => !prevLogout)}
    >
      <div
        className={`profile-card__circle ${header ? 'profile-card__header' : ''} ${
          isLogOutButton ? 'profile-card__header--cursor' : ''
        }`}
        data-testid='profile'
      >
        {profilePhoto ? (
          <img className='profile-card__photo' src={profilePhoto} alt={'foto'} />
        ) : (
          <>
            {name?.toUpperCase()}
            {secondName?.toUpperCase()}
          </>
        )}
      </div>
      {logout && header && (
        <div
          className='logout-button fadeInDown'
          onClick={(e) => {
            e.stopPropagation();
            handleClick();
          }}
          ref={cardRef}
        >
          <AImage
            className='header_logo__image'
            url={logoutIcon}
            alt=''
            dataTestid='desktop-logo'
          />
          <p>{LOGOUT}</p>
        </div>
      )}
    </div>
  );
};
